import Vue from 'vue'
import Router from 'vue-router'
import auth from './layouts/auth'
import login from './pages/login'
import report from './pages/report'
import reportFlota from './pages/reportFlota'
import reportDriver from './pages/reportDriver'
import service from './pages/service'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/auth/login'
    },
    {
      path: '/auth',
      redirect: '/auth/login'
    },
    {
      path: '/auth/login',
      name: 'login',
      component: login
    },
    {
      path: '/auth',
      name: 'layoutAuth',
      component: auth,
      redirect: '/auth/login',
      children: [{
        path: '/reporte',
        name: 'report',
        component: report
      }, {
        path: '/reporte-flota',
        name: 'reportFlota',
        component: reportFlota
      },
      {
        path: '/reporte/:month/:year/:driverID',
        name: 'report-driver',
        component: reportDriver
      },
      {
        path: '/servicio/:IDPay',
        name: 'service',
        component: service
      }]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router.js